const __version__ ='prime_v1.0.0'

module.exports = {
    __version__
}

